import { __ } from '@wordpress/i18n';

const PAYMENT_ICONS = ['visa.svg', 'mastercard.svg', 'amex.webp', 'jcb.svg', 'ideal.svg', 'paypal-monogram.webp'];

const Security = () => {
    const imgDir = window['JkitDashboardOption']?.imgDir || '';

    return (
        <div className="f-pricing__security">
            <div className="f-pricing__security-top">
                <img
                    src={imgDir + 'pricing/shield-icon.svg'}
                    alt="Secure"
                    className="f-pricing__secure-shield"
                />
                <span>{__('Secure payments by', 'jeg-elementor-kit')}</span>
                <img
                    src={imgDir + 'pricing/freemius.svg'}
                    alt={__('Freemius', 'jeg-elementor-kit')}
                    className="f-pricing__freemius-logo"
                />
            </div>
            <div className="f-pricing__payment-logos">
                {PAYMENT_ICONS.map((name) => (
                    <img
                        key={name}
                        src={imgDir + `pricing/${name}`}
                        alt={name}
                        className="f-pricing__payment-icon"
                    />
                ))}
            </div>
            <div className="f-pricing__trust-badges">
                <img src={imgDir + 'pricing/mcafee.png'} alt="McAfee Secure" className="f-pricing__trust-img" />
                <img src={imgDir + 'pricing/paypal.svg'} alt="PayPal Verified" className="f-pricing__trust-img f-pricing__trust-img--paypal" />
                <img src={imgDir + 'pricing/cloudflare.png'} alt="Cloudflare" className="f-pricing__trust-img" />
            </div>
        </div>
    );
};

export default Security;
